import { Action, ICON_CALENDAR_OUTLINE } from '@doveit/bricks';
import React, { FunctionComponent, useState, useCallback } from 'react';
import { mutate } from 'swr';
import { saveColdLeadContactNoAnswer, saveLeadContactNoAnswer } from '../../../providers/api/call-center/callCenterLeadProvider';
import { CallContextType } from '../../../providers/api/dtos/call';
import { CONTACT_RID } from '../../../contact/hooks/use-contact/useContact';
import { saveFeedbackContactNoAnswer } from '../../../providers/api/call-center/callCenterFeedbackProvider';

export interface NoAnswerActionProps {
  contactId: string,
  disabled?: boolean,
  type: CallContextType
  onSuccess?: () => void,
  onError?: (error: string) => void,
}

const DEFAULT_ERROR_MESSAGE = 'Non è stato possibile aggiornare il contatto e le sue lead.';

const NoAnswerAction: FunctionComponent<NoAnswerActionProps> = ({
  contactId,
  disabled,
  type,
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);

  const onButtonClick = useCallback(async () => {
    setLoading(true);

    try {
      switch (type) {
        case CallContextType.LEAD:
          await saveLeadContactNoAnswer(contactId);
          break;
        case CallContextType.COLD_LEAD:
          await saveColdLeadContactNoAnswer(contactId);
          break;
        case CallContextType.SURVEY:
          await saveFeedbackContactNoAnswer(contactId);
          break;
        default:
      }
      setLoading(false);

      mutate([CONTACT_RID, contactId]);

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setLoading(false);

      if (onError) {
        onError(DEFAULT_ERROR_MESSAGE);
      }
    }
  }, [contactId, onError, onSuccess, type]);

  return (
    <Action
      label="Non risponde"
      color="warning"
      emphasis="high"
      iconLeft={{ path: ICON_CALENDAR_OUTLINE }}
      loading={loading}
      disabled={disabled}
      onClick={onButtonClick}
    />
  );
};

export default NoAnswerAction;
